import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getWorkouts, getTempWorkouts, saveWorkout, deleteWorkouts, getTrainers,
          saveTempWorkout, deleteTempWorkouts, saveWorkoutsToProd, getExerciseMapping
        } from '../../actions';
import Modal from '../../components/modal/modal';
import './workouts.css';

class Workouts extends Component {
  initState = {
    show: false,
    showInnerModal: false,
    innerExercises: false,
    innerInterruptTimes: false,
    innerFront: false,
    checkedWorkout: [],
    checkedTempWorkout: [],
    workoutSearch: '',
    workoutTempSearch: '',
    unready: false,
    _id: '',
    trainer_name: '',
    trainer_profile_picture: '',
    trainer: '',
    name: '',
    level: 'BEGINNER',
    duration: '',
    total_seconds: '',
    calories: '',
    intensity: 'LOW',
    start_image: '',
    summary_image: '',
    description: '',
    target_areas: 'FULL BODY',
    equipment: 'None',
    video_path: '',
    video_end_point: '',
    video_aws_s3_key: '',
    exercises: [],
    interrupt_times: [],
    points: ''
  }

  state = {
    workouts: [],
    ...this.initState
  }

  componentWillMount = () => {
    this.props.getWorkouts();
    this.props.getTempWorkouts();

    if(!this.props.trainers) {
      this.props.getTrainers();
    }

    if(!this.props.exerciseMapping) {
      this.props.getExerciseMapping();
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if((nextProps.workoutSaved && nextProps.workoutSaved.success) || 
        (nextProps.deleteWorkout && nextProps.deleteWorkout.success) ||
        nextProps.saveToProd 
      ) {
      return this.props.getWorkouts();
    }

    if((nextProps.workoutTempSaved && nextProps.workoutTempSaved.success) || 
        (nextProps.deleteTempWorkout && nextProps.deleteTempWorkout.success)
      ) {
      return this.props.getTempWorkouts();
    }

    if (Array.isArray(nextProps.workouts)) {
      this.setState({
        workouts: nextProps.workouts,
        tempWorkouts: nextProps.tempWorkouts
      })
    }

    if (Array.isArray(nextProps.tempWorkouts)) {
      this.setState({
        tempWorkouts: nextProps.tempWorkouts
      })
    }
  }

  showModal = (type) => {
    switch(type) {
      case 'workout':
        this.setState({
          show: true,
        });
        break;
      case 'innerExercises':
        this.setState({
          innerExercises: true,
          showInnerModal: true,
        });
        break;
      case 'innerInterruptTimes':
        this.setState({
          innerInterruptTimes: true,
          showInnerModal: true,
        });
        break;
      case 'innerFront':
        this.setState({
          innerFront: true,
          showInnerModal: true,
        });
        break;
      default:
        break;
    }
  }

  hideModal = (type) => {
    switch(type) {
      case 'workout':
        this.setState({
          show: false,
          ...this.initState
        });
        break;
      case 'inner':
        this.setState({
          innerExercises: false,
          innerInterruptTimes: false,
          innerFront: false,
          showInnerModal: false,
        });
        break;
      // case 'innerInterruptTimes':
      //   this.setState({
      //     innerExercises: false,
      //     innerInterruptTimes: false,
      //     innerFront: false,
      //     showInnerModal: false,
      //   });
      //   break;
      // case 'innerFront':
      //   this.setState({
      //     innerExercises: false,
      //     innerFront: false,
      //     innerInterruptTimes: false,
      //     showInnerModal: false,
      //   });
      //   break;
      default:
        break;
    }
  }

  handleChange = (evt, index, type ) => {
    let value = evt.target.value;
    const name = evt.target.name;
    
    value = Number(value) ? Number(value) : value
    switch(type) {
      case 'innerExercises':
        let exercises = this.state.exercises;
        if(name === 'present_name') {
          exercises[index][name] = value.toUpperCase();

          let mapping = this.props.exerciseMapping.find(exercise => exercise.present_name ===  value.toUpperCase())
          Object.keys(mapping).forEach(key => {
            if(key !== '_id') {
              exercises[index][key] = mapping[key]
            } else {
              exercises[index].exerciseMapping = mapping['_id']
            }
          })
        } else {
          exercises[index][name] = value
        }
        this.setState({
          ...this.state,
          exercises
        });
        break;
      case 'innerInterruptTimes':
        let interruptTimes = this.state.interrupt_times;
        interruptTimes[index][name] = value
        this.setState({
          ...this.state,
          interrupt_times :interruptTimes
        });
        break;
      default:
        this.setState({
          ...this.state,
          [evt.target.name]: value
        });

        if(evt.target.name === 'trainer_name') {
          this.setState({
            trainer_profile_picture: this.props.trainers.find(trainer => trainer.details.first_name + " " + trainer.details.last_name === value).details.profile_pic,
            trainer: this.props.trainers.find(trainer => trainer.details.first_name + " " + trainer.details.last_name === value)._id
          })
        }else if(evt.target.name === 'workoutSearch') {
          this.props.getWorkouts(value);
        }else if(name === 'workoutTempSearch') {
          this.props.getTempWorkouts(value);
        }
        break;
    }
  }

  submitForm = (e) => {
    e.preventDefault();
    this.setState({
      ...this.initState
    });

    if (this.state.unready) {
      console.log(this.state.exercises);
      this.props.saveTempWorkout(this.state);
      return
    } else {
      this.props.saveWorkout(this.state);
    }


  }

  
  editWorkout = (workout, type) => {
    if (type === 'unready') {
      this.setState({
        unready:true
      })
    }
    this.setState({
      _id: workout._id || '',
      trainer_name: workout.trainer_name || '',
      trainer_profile_picture: workout.trainer_profile_picture || '',
      trainer: workout.trainer || '',
      name: workout.name || '',
      level: workout.level || 'BEGINNER',
      duration: workout.duration || '',
      total_seconds: workout.total_seconds || '',
      calories: workout.calories || '',
      intensity: workout.intensity || 'LOW',
      start_image: workout.start_image || '',
      summary_image: workout.summary_image || '',
      description: workout.description || '',
      target_areas: workout.target_areas || 'FULL BODY',
      equipment: workout.equipment || 'None',
      video_path: workout.video_path || '',
      video_end_point: workout.video_end_point || '',
      video_aws_s3_key: workout.video_aws_s3_key || '',
      exercises: workout.exercises || [],
      interrupt_times: workout.interrupt_times || [],
      points: workout.points || ''
    })
    this.showModal('workout');
  }

  addInner = (e, type) => {
    e.preventDefault();
    switch(type) {
      case 'innerExercises':
        this.setState({
          exercises: [...this.state.exercises, {
            present_name: '',
            name: '',
            type: '',
            start_time: '',
            end_time: '',
            total_seconds: '',
            total_reps: ''
          }]
        });
        break;
      case 'innerInterruptTimes':
        this.setState({
          interrupt_times: [...this.state.interrupt_times, {
            start_time: '',
            end_time: '',
            state: true
          }]
        });
        break;
      default:
        break;
    }
  }
  
  addWorkout = (e, type) => {
    e.preventDefault();
    if(type === 'unready') {
      this.setState({
        unready: true
      })
    }
    this.showModal('workout');
  }

  removeInner = (e, index) => {
    e.preventDefault();
    if (this.state.innerExercises) {
      let exercises = this.state.exercises.filter((exercise, i) => i !== index);
      this.setState({
        exercises
      })
    } else if(this.state.innerInterruptTimes) {
      let interrupt_times = this.state.interrupt_times.filter((time, i) => i !== index);
      this.setState({
        interrupt_times
      })
    }
  }
  
  checkboxClick = (workout, type) => {
    if(type === 'unready'){
      let index = this.state.checkedTempWorkout.indexOf(workout._id);
      if(index !== -1) {
        let checked = this.state.checkedTempWorkout.filter(checkedW => checkedW !== workout._id)
        
        this.setState({
          checkedTempWorkout: checked
        })
      } else {
        this.setState({
          checkedTempWorkout: [...this.state.checkedTempWorkout, workout._id]
        })
      }
    } else {
      let index = this.state.checkedWorkout.indexOf(workout._id);
      if(index !== -1) {
        let checked = this.state.checkedWorkout.filter(checkedW => checkedW !== workout._id)
        
        this.setState({
          checkedWorkout: checked
        })
      } else {
        this.setState({
          checkedWorkout: [...this.state.checkedWorkout, workout._id]
        })
      }
    }
  }

  deleteWorkout = (e, type) => {
    e.preventDefault();
    this.setState({
      ...this.initState
    })
    
    if (type === 'unready') {
      return this.props.deleteTempWorkouts(this.state.checkedTempWorkout);
    }
    this.props.deleteWorkouts(this.state.checkedWorkout);
  }

  addFinalWorkout = () => {
    this.state.checkedTempWorkout.forEach(id => {
      let tempWorkout = this.state.tempWorkouts.find(workout => workout._id === id);
      this.props.saveWorkout(tempWorkout);
    })
  }

  addToProduction = () => {
    let workouts = [];
    this.state.checkedWorkout.forEach(id => {
      workouts.push(this.state.workouts.find(workout => workout._id === id));
    })

    this.setState({
      ...this.initState
    })
    if(workouts.length > 0) {
      this.props.saveWorkoutsToProd(workouts);
    }
  }
  renderWorkouts = (type) => (
    type === 'unready' ?
    this.state.tempWorkouts && Array.isArray(this.state.tempWorkouts)? 
      this.renderWorkoutsMap(this.state.tempWorkouts, type)
      : null
    :
    this.state.workouts && Array.isArray(this.state.workouts)? 
      this.renderWorkoutsMap(this.state.workouts, type)
    : null
  )

  renderWorkoutsMap = (workouts, type) => (
    workouts.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    .map((workout, i) => {
      return <div key={i} className="inline-row-workout"> 
        <div className="column column-checkbox" ><input className="checkbox" type="checkbox" name="workoutCheckbox" 
          checked={type ==='unready' ?  
          this.state.checkedTempWorkout.indexOf(workout._id) === -1 ? false : true
          : this.state.checkedWorkout.indexOf(workout._id) === -1 ? false : true } 
          onChange={() => this.checkboxClick(workout, type)}/></div>
        <div className="column column-name" onClick={() => { this.editWorkout(workout, type)}}> {workout.name} </div>
        <div className="column"> {workout.level} </div>
      </div>
    }) 
  )

  renderTrainers = (trainers) => (
    trainers ? 
    trainers.map((option, j) => { 
      return <option key={j} value={ option.details.first_name + " " +  option.details.last_name }> 
        { option.details.first_name + " " +  option.details.last_name }</option> 
    }):
    null
  )

  renderPresentName = (exercises) => (
    exercises ? 
    exercises.sort((a,b) => (a.present_name > b.present_name) ? 1 : ((b.present_name > a.present_name) ? -1 : 0))
    .map((exercise, j) => { 
      return <option key={j} value={exercise.present_name}> { exercise.present_name }</option> 
    }):
    null
  )

  renderExercises = () => (
    this.state.exercises.map((exercise, i) => {
      return <div key={i} className="inline">
        <div>
          <button className="close deleteInner" onClick={(e) => this.removeInner(e, i)}>&times;</button>
        </div>
        <div className="exercise-div">
          <div className="inline inner-div">
            <h5 className="inner-title">Present Name</h5>
            <select className="inner-input inner-select" name="present_name" type="text" placeholder="Present Name" value={exercise.present_name || ''} onChange={(e) => this.handleChange(e, i,'innerExercises')}>
              <option>Select</option>
              {this.renderPresentName(this.props.exerciseMapping)}
            </select>
          </div>
          <div className="inline inner-div">
            <h5 className="inner-title">Name</h5>
            <input className="inner-input"  name="name" type="text" placeholder="Name" value={exercise.name} readOnly={true}/>
          </div>
          <div className="inline inner-div">
            <h5 className="inner-title">Type</h5>
            <input className="inner-input" name="type" type="text" placeholder="Type" value={exercise.type} readOnly={true}/>
          </div>
          <div className="inline inner-div">
            <h5 className="inner-title">Start Time</h5>
            <input className="inner-input"  name="start_time" type="number" placeholder="Start Time" value={exercise.start_time} onChange={(e) => this.handleChange(e, i,'innerExercises')}/>
          </div>
          <div className="inline inner-div">
            <h5 className="inner-title">End Time</h5>
            <input className="inner-input"  name="end_time" type="number" placeholder="End Time" value={exercise.end_time} onChange={(e) => this.handleChange(e, i,'innerExercises')}/>
          </div>
          <div className="inline inner-div">
            <h5  className="inner-title">Total Seconds</h5>
            <input className="inner-input"  name="total_seconds" type="number" placeholder="Total Seconds" readOnly={true}
                value={exercise.end_time && exercise.start_time ? exercise.end_time - exercise.start_time : ''}/>
          </div>
          <div className="inline inner-div">
            <h5 className="inner-title">Total Reps</h5>
            <input className="inner-input"  name="total_reps" type="number" placeholder="Total Reps" value={exercise.type === 'TIME' ? 0 : exercise.total_reps} onChange={(e) => this.handleChange(e, i,'innerExercises')}/>
          </div>
          <div className="inline inner-div">
            <h5 className="inner-title">Front</h5>
            <input className="inner-input" name="front" type="front" placeholder="Front" value={exercise.front || 'TRAINER'} readOnly={true}/>
          </div>
          <div className="inline inner-div">
            <h5 className="inner-title">Bars</h5>
            <input className="inner-input" name="bars" type="bars" placeholder="Bars" value={exercise.bars || false} readOnly={true}/>
          </div>
          <div className="inline inner-div">
            <h5 className="inner-title">Score</h5>
            <input className="inner-input" name="score" type="score" placeholder="Score" value={exercise.score || false} readOnly={true}/>
          </div>
          <div className="inline inner-div">
            <h5 className="inner-title">Skeleton</h5>
            <input className="inner-input" name="skeleton" type="skeleton" placeholder="Skeleton" value={exercise.skeleton || false} readOnly={true}/>
          </div>
        </div>
      </div>
    })
  )

  renderInterruptTimes = () => (
    this.state.interrupt_times.map((time, i) => {
      return <div key={i} className="inline" >
        <div>
          <button className="close deleteInner" onClick={(e) => this.removeInner(e, i)}>&times;</button>
        </div>
        <div  className="exercise-div">
          <div className="inline inner-div">
            <h5 className="inner-title">Start Time</h5>
            <input className="inner-input" name="start_time" type="number" placeholder="Start Time" value={time.start_time} onChange={(e) => this.handleChange(e, i,'innerInterruptTimes')}/>
          </div>
          <div className="inline inner-div">
            <h5 className="inner-title">End Time</h5>
            <input className="inner-input"  name="end_time" type="number" placeholder="End Time" value={time.end_time} onChange={(e) => this.handleChange(e, i,'innerInterruptTimes')}/>
          </div>
          <div className="inline inner-div">
            <h5 className="inner-title">State</h5>
            <select className="inner-input inner-select"  name="state" type="text" placeholder="State" value={time.state} onChange={(e) => this.handleChange(e, i,'innerInterruptTimes')}>
              <option>Select</option>
              <option value={true}>true</option>
              <option value={false}>false</option>
            </select>
          </div>
        </div>
      </div>
    })
  )

  render() {
    let user = this.props.user;
    return (
      <div className="">
        <Modal show={this.state.show} handleClose={() => {this.hideModal('workout')}}>
          <form className="workout_form" onSubmit={this.submitForm}>
            <div className="tariner">
              <div className="inline">
                <h5>Trainer name</h5>
                <select name="trainer_name" type="text" placeholder="Trainer name" value={this.state.trainer_name} onChange={this.handleChange}>
                  <option>Select Trainer</option>
                  {this.renderTrainers(this.props.trainers)}
                </select>
              </div>
              <div className="inline">
                <h5>Trainer Profile Picture</h5>
                <input type="text" placeholder="Trainer Profile Picture" name="trainer_profile_picture" value={this.state.trainer_profile_picture} readOnly={true}/>
              </div>
              <div className="inline">
                <h5>Trainer Id</h5>
                <input type="text" placeholder="Trainer Id"  name="trainer" value={this.state.trainer} readOnly={true}/>
              </div>
              <div className="inline">
                <h5>Name</h5>
                <input type="text" placeholder="Name"  name="name" value={this.state.name} onChange={this.handleChange}/>
              </div>
            </div>
            <div className="tariner">
              <div className="inline">
                <h5>Level</h5>
                <select name="level" onChange={this.handleChange} value={this.state.level} required>
                    <option name="BEGINNER" value="BEGINNER">BEGINNER</option>
                    <option name="INTERMEDIATE" value="INTERMEDIATE">INTERMEDIATE</option>
                    <option name="ADVANCED" value="ADVANCED">ADVANCED</option>
                </select>
              </div>
              <div className="inline">
                <h5>Duration</h5>
                <input type="text" placeholder="Duration"  name="duration" value={this.state.duration} onChange={this.handleChange}/>
              </div>
              <div className="inline">
                <h5>Total Seconds</h5>
                <input type="number" placeholder="Total Seconds"  name="total_seconds" value={this.state.total_seconds} onChange={this.handleChange}/>
              </div>
              <div className="inline">
                <h5>Calories</h5>
                <input type="number" placeholder="Calories"  name="calories" value={this.state.calories} onChange={this.handleChange}/>
              </div>
            </div>
            <div className="tariner">
              <div className="inline">
                <h5>Intensity</h5>
                <select name="intensity"  onChange={this.handleChange} value={this.state.intensity} required>
                    <option name="low" value="LOW">LOW</option>
                    <option name="mid" value="MID">MID</option>
                    <option name="high" value="HIGH">HIGH</option>
                </select>
              </div>
              <div className="inline">
                <h5>Start Image</h5>
                <input type="text" placeholder="Start Image"  name="start_image" value={this.state.start_image} onChange={this.handleChange}/>
              </div>
              <div className="inline">
                <h5>Summary Image</h5>
                <input type="text" placeholder="Summary Image"  name="summary_image" value={this.state.summary_image} onChange={this.handleChange}/>
              </div>
              <div className="inline">
                <h5>Description</h5>
                <input type="text" placeholder="Description"  name="description" value={this.state.description} onChange={this.handleChange}/>
              </div>
            </div>
            <div className="tariner">
              <div className="inline">
                <h5>Target Areas</h5>
                <input type="text" placeholder="Target Areas"  name="target_areas" value={this.state.target_areas} onChange={this.handleChange}/>
              </div>
              <div className="inline">
                <h5>Equipment</h5>
                <input type="text" placeholder="Equipment"  name="equipment" value={this.state.equipment} onChange={this.handleChange}/>
              </div>
              <div className="inline">
                <h5>Video_path</h5>
                <input type="text" placeholder="Video_path"  name="video_path" value={this.state.video_path} onChange={this.handleChange}/>
              </div>
              <div className="inline">
                <h5>Video End Point</h5>
                <input type="text" placeholder="Video End Point"  name="video_end_point" value={this.state.video_end_point} onChange={this.handleChange}/>
              </div>
            </div>
            <div className="tariner">
              <div className="inline">
                <h5>Video AWS s3 Key</h5>
                <input type="text" placeholder="Video AWS s3 Key"  name="video_aws_s3_key" value={this.state.video_aws_s3_key} onChange={this.handleChange}/>
              </div>
              <div className="inline">
                <h5>Points</h5>
                <input type="text" placeholder="Points"  name="points" value={this.state.points} onChange={this.handleChange}/>
              </div>
              <div className="inline">
                <h5 className="open_model" onClick={() => this.showModal('innerExercises')}>Exercises</h5>
              </div>
              <div className="inline">
                <h5 className="open_model" onClick={() => this.showModal('innerInterruptTimes')}>Interrupt Time</h5>
              </div>
            </div>
            <button type="submit" className="savebtn">Save</button> 
          </form>
        </Modal>
        <Modal inner={true} show={this.state.showInnerModal} handleClose={() => { this.hideModal('inner')}}>
          {
            this.state.innerExercises ? 
              this.renderExercises() :
            this.state.innerInterruptTimes ? 
              this.renderInterruptTimes() :
              null
          }
          {
            this.state.innerExercises ? 
             <button onClick={(e) => {this.addInner(e, 'innerExercises')}} className="savebtn addButton-inner">Add</button> :
            this.state.innerInterruptTimes ? 
              <button onClick={(e) => {this.addInner(e, 'innerInterruptTimes')}} className="savebtn addButton-inner">Add</button> :
            null
          }
        </Modal>
        <div className="inline">
              <div className="workouts-div">
                <h2 className="workout-title">WORKOUTS</h2>
                <div className="inline">
                  <input className="select-motivation search-input search-workout" type="text" placeholder="Search"  name="workoutSearch" value={this.state.workoutSearch} onChange={this.handleChange}/>
                  <button onClick={this.addWorkout} className="addButton">Add</button>
                  <button onClick={this.deleteWorkout} className="addButton">Delete</button>
                  {
                    process.env.REACT_APP_ENVIRONMENT !== 'production'  ?
                      <button onClick={this.addToProduction} className="addButton final-btn">Add To Production</button>
                    : null
                  }
                </div>
                <div className="specific-feedbacks-head inline-row-workout">
                  <div className="column column-head column-checkbox"></div>
                  <div className="column column-head column-name">Name</div>
                  <div className="column column-head">Level</div>
                </div>
                <div className="specific-feedbacks">
                  {this.renderWorkouts()}
                </div> 
                {
                    this.props.workoutSaved && !this.props.workoutSaved.success && this.props.workoutSaved.error ? 
                    <p className="error-message">Error Saving workout - { this.props.workoutSaved.error.message }</p> : 
                    null
                  }
              </div>
          {
            process.env.REACT_APP_ENVIRONMENT !== 'production' ? 
            <div className="unready-div">
              <h2 className="workout-title">EDIT WORKOUTS</h2>
              <div className="inline">
              <input className="select-motivation search-input search-workout" type="text" placeholder="Search"  name="workoutTempSearch" value={this.state.workoutTempSearch} onChange={this.handleChange}/>
                <button onClick={(e) => this.addWorkout(e, 'unready')} className="addButton">Add</button>
                <button onClick={(e) => this.deleteWorkout(e, 'unready')} className="addButton">Delete</button>
                {
                  user && user.login && user.login.role !== 'EDIT' ?
                    <button onClick={this.addFinalWorkout} className="addButton final-btn">Add To Workouts</button>
                  : null
                }
              </div>
              <div className="specific-feedbacks-head inline-row-workout">
                <div className="column column-head column-checkbox"></div>
                <div className="column column-head column-name">Name</div>
                <div className="column column-head">Level</div>
              </div>
              <div className="specific-feedbacks">
                {this.renderWorkouts('unready')}
              </div> 
            </div>
            : null
          }
          </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
   loginStatus: state.login,
    workouts: state.workout.workouts,
    workoutSaved: state.workout.saveWorkout,
    deleteWorkout: state.workout.deleteWorkouts,
    tempWorkouts: state.workout.tempWorkouts,
    workoutTempSaved: state.workout.saveTempWorkout,
    deleteTempWorkout: state.workout.deleteTempWorkouts,
    saveToProd: state.workout.saveToProd,
    exerciseMapping: state.workout.exerciseMapping,
    trainers: state.user.trainers,
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ getWorkouts, getTempWorkouts, deleteTempWorkouts, saveWorkoutsToProd,
             saveWorkout, saveTempWorkout, deleteWorkouts, getTrainers, getExerciseMapping },dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Workouts);